import React from 'react'
import ReactDOM from 'react-dom/client'
import {QueryClient, QueryClientProvider} from 'react-query'
import './index.scss'
import App from 'pages/App/App'
import {AuthProvider} from 'contexts/AuthContext'
import {ToastContainer} from 'react-toastify'
import {GlobalProvider} from 'contexts/GlobalContext'
//import {LoadScript} from '@react-google-maps/api'
//import {GOOGLE_MAPS_LIBRARIES} from 'utils/constants'
import {UserProvider} from 'contexts/UserContext'
import 'react-toastify/dist/ReactToastify.css'
import 'react-phone-number-input/style.css'
import {captureReferralFromUrl} from 'utils/referral'

const legacyHashRedirects = {
  '#/customer-login': '/login',
  '#/sign-up': '/register',
  '#/signup': '/register',
  '#/login': '/login',
  '#/enterprise-account-sign-up': '/register',
  '#/retail-account-sign-up': '/register',
}

const newPath = legacyHashRedirects[window?.location?.hash]
if (newPath) {
  window.history.replaceState(null, '', newPath)
}

captureReferralFromUrl()

const queryClient = new QueryClient()
//const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <UserProvider>
        <GlobalProvider>
          <App />
        </GlobalProvider>
        <ToastContainer
          style={{minWidth: '350px'}}
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          closeOnClick
          pauseOnHover
          draggable
          progress={undefined}
          theme="colored"
          toastClassName={() => 'no-icon-toast'}
        />
      </UserProvider>
    </AuthProvider>
  </QueryClientProvider>
)
